import React from 'react';

const TextAreaField = ({
  label,
  name,
  placeholder = '',
  value,
  onChange,
  rows = 4,
  required = false,
  disabled = false,
  errorMessage = '',
}) => {
  return (
    <div className="">
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
        </label>
      )}
      <textarea
        name={name}
        id={name}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={`appearance-none block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
          errorMessage ? 'border-red-500' : 'border-gray-300'
        } ${disabled ? 'bg-gray-200' : 'bg-white'}`}
      />
      {errorMessage && (
        <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default TextAreaField;
